import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getOrderCSVApi, OrderCSVRequest } from "./api";
import { State } from "@features/base/types";

export const getOrderCSV = createAsyncThunk<
  unknown,
  { userId: string; data: OrderCSVRequest }
>("general/getOrderCSV", async ({ userId, data }, { rejectWithValue }) => {
  try {
    return await getOrderCSVApi(userId, data);
  } catch (error) {
    return rejectWithValue(error);
  }
});

type GeneralState = State<unknown>;

const initialState: GeneralState = {
  loading: false,
  error: null,
};

const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrderCSV.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrderCSV.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getOrderCSV.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default generalSlice.reducer;
